import addError from '../../../utils/error.jsx';

export function request(sportId, eventTemplateId, marketTemplateId, id, data) {
    return {
        type: 'MARKET_TEMPLATES_UPDATE_SELECTION_REQUEST',
        marketTemplateId,
        eventTemplateId,
        sportId,
        data,
        id
    };
}

export function error(id, marketTemplateId, errors) {
    addError(errors);

    return {
        type: 'MARKET_TEMPLATES_UPDATE_SELECTION_ERROR',
        errors,
        marketTemplateId,
        id
    };
}

export function finish(id, marketTemplateId, data) {
    return {
        type: 'MARKET_TEMPLATES_UPDATE_SELECTION_FINISH',
        data,
        marketTemplateId,
        id
    };
}
